// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + ({"214":"polyfills-core-js","748":"polyfills-dom"}[chunkId] || chunkId) + "." + {"214":"23a01804","351":"c935b8f8","748":"1b6d2028"}[chunkId] + ".chunk.js";
};